import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "cms-catalog-tree",
  name: "栏目导航树",
  icon: "栏",
  group: "CMS通用",
  description: "展示当前站点的栏目导航树，支持多级展开与筛选。",
  defaultProps: {
    "showAll": true,
    "allLabel": "全部",
    "expandable": true
}
}
